import { HTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'sm' | 'md' | 'lg';
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ padding = 'md', className, children, ...props }, ref) => {
    const paddingClasses = { sm: 'p-4', md: 'p-5', lg: 'p-6' };
    return (
      <div
        ref={ref}
        className={clsx(
          'rounded-[22px] border border-gray-900/6 bg-white/82',
          'shadow-[0_10px_18px_rgba(0,0,0,0.06)]',
          paddingClasses[padding],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';
